import { useQuery } from '@apollo/client';
import { FetchHostNotificationsDocument } from '@website/types/graphqlOperations';
import ErrorPage from '../utilities/ErrorPage';
import LoadingPage from '../utilities/LoadingPage';
import Notifications from './Notifications';

type Props = {
  urlSlug: string;
};

export default function HostNotifications({ urlSlug }: Props) {
  const { loading, error, data } = useQuery(FetchHostNotificationsDocument, {
    variables: {
      urlSlug,
    },
    fetchPolicy: 'cache-and-network',
  });

  if (loading && !data) {
    return <LoadingPage />;
  }

  if (error && !data) {
    return <ErrorPage />;
  }

  return <Notifications notifications={data.hostByURL.notifications.items} />;
}
